import Favorite from "./Favorite";
import firebase from "firebase/app";
import "firebase/auth";
const arrayMove = require("array-move");

const db = firebase.firestore();

// favoritesMeta {
// 	userId: {
// 		order: ["id1", "id2", "id3", ... ],
//    updatedAt
//  }
// }

class FavoritesMeta {
  constructor(userId, documentId, data) {
    this.userId = userId;
    this.documentId = documentId;

    if (!data.favoritesOrder) {
      throw new Error("FavoritesMeta must have an order field");
    }
    this.order = data.favoritesOrder;
  }

  static async get(userId, documentId) {
    let snap = await db.collection("userData").doc(userId).collection("documentMetas").doc(documentId).get();
    return new FavoritesMeta(userId, documentId, snap.data());
  }

  // creates a new favorite at the top of the list
  async createFromCard(card, content) {
    // check that we haven't favorited before
    let existing = await Favorite.exists(card.id, content, this.userId);
    if (existing) {
      // Orphan recovery: a prior client-side failure could leave a server record
      // that isn't in our order. Splice it in so the client cache picks it up.
      if (!this.order.includes(existing.id)) {
        this.order.unshift(existing.id);
        this.save();
        return existing;
      }
      console.log("Already favorited (server hit)");
      return false;
    }

    //TODO: check for staleness
    let favorite = await Favorite.createFromCard(card, content);

    // update the order
    this.order.unshift(favorite.id);

    this.save();

    return favorite;
  }

  // deletes a favorite based on card and content
  async deleteFromCard(card, content) {
    let favorite = await Favorite.exists(card.id, content, this.userId);
    if (favorite) {
      return await this.delete(favorite);
    } else {
      return false;
    }
  }

  // deletes a favorite, optimistically update on client before saving to server
  async delete(favorite) {
    // purge from order
    let idx = this.order.findIndex((id) => {
      return id === favorite.id;
    });

    // delete on server
    favorite.delete();

    if (idx !== -1) {
      //TODO: check for staleness
      this.order.splice(idx, 1);
      this.save();
      return favorite.id;
    } else {
      return false;
    }
  }

  // saves the meta object
  async save() {
    return db.collection("userData").doc(this.userId).collection("documentMetas").doc(this.documentId).update({ favoritesOrder: this.order });
  }

  reorder(from, to) {
    // TODO: do sanity checks here
    // TODO: sync with server first

    // reorder on client
    this.order = arrayMove(this.order, from, to);

    // call asynchronously but don't wait for result
    this.save();
  }
}

export default FavoritesMeta;
